import { Button } from '@hologram-dimension/button';
import { EmptyState } from 'components';
import useOrganization from 'state/contexts/Organization/useOrganization';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import useSimUrl from 'utils/hooks/useSimUrl';
import EnumSimPage from 'utils/legacy/paths/simPage';
import useAnalytics from 'state/contexts/Analytics/useAnalytics';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';
import styles from './ActiveProfileIccidRenderer.module.css';

interface ActiveProfileIccidRendererProps
  extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const ActiveProfileIccidRenderer = ({
  value,
  customProps,
}: ActiveProfileIccidRendererProps): CustomCellRendererReturn => {
  const { simDetailBaseUrl } = customProps;

  const orgId = useOrganization();

  const url = useSimUrl({
    simDetailBaseUrl,
    orgId,
    simId: value.hologramSimId,
    subpage: EnumSimPage.profiles,
  });

  const { sendAnalyticsEvent } = useAnalytics();

  const handleAnalytics = () => {
    if (sendAnalyticsEvent)
      sendAnalyticsEvent('ICCID', {
        activeProfileIccid: value.activeProfileIccid,
      });
  };

  if (!value.activeProfileIccid) return <EmptyState />;

  if (!url) return <EmptyState />;

  // TODO: If the active profile is the backup profile, show the fallback shield icon and " (backup" suffix in diminished grey
  return (
    <Button
      className={styles.wrapper}
      variant="tertiary"
      noPadding
      to={url}
      accessibleText={`${value.activeProfileIccid} - View profiles`}
      onClick={handleAnalytics}
    >
      {value.activeProfileIccid}
    </Button>
  );
};

export default ActiveProfileIccidRenderer;
